import * as api from '../prospectsApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  CreateProspect,
  IProspectApiResponse,
  prospectActionCreators,
  ProspectsActionKeys
  } from '..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { processMessages } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';

function* createProspectSaga(action: CreateProspect) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IEntityWithMessages<IProspectApiResponse> = yield call(api.CreateProspect, action.payload);

  if (!response.error && response.value) {
    yield put(prospectActionCreators.updateProspectFulfilled(response.value));
  }

  yield processMessages(
    response,
    `The following problems occured trying to create ${action.payload.name}:`,
    `An exception occured trying to create this prospect.
  Please retry.  If this problem persists, contact IT`
  );

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchCreateProspect() {
  yield takeEvery(ProspectsActionKeys.CREATE_PROSPECT, createProspectSaga);
}
